import { NotFound } from "@dgs/core";
import { FC } from "react";
import { Route, Routes } from "react-router";
import { UserResponsibilityList } from "./UserResponsibilityList";

export const UserResponsibilityPage: FC = () => {
	return (
		<Routes>
			<Route index element={<UserResponsibilityList />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
